var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sd-loading-indicator" },
    [
      _c("sv-svg-icon", {
        attrs: { iconName: "icon-loading", size: "'auto'" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }